import script from "./GateLoginPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./GateLoginPanel.vue?vue&type=script&setup=true&lang=ts"

import "./GateLoginPanel.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__